const MAX_LONG_EDGE = 3000;
const JPEG_QUALITY = 0.85;

/**
 * Normalizes mobile slot photos before upload. Re-encoding is intentional even for smaller
 * images: it keeps payloads predictable and strips EXIF from operational checklist evidence.
 * Damage-report evidence does not use this path and keeps its original bytes.
 */
export async function compressCleaningPhoto(file: File): Promise<File> {
  const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
  try {
    const scale = Math.min(1, MAX_LONG_EDGE / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const context = canvas.getContext('2d');
    if (!context) throw new Error('Foto konnte nicht verarbeitet werden.');
    context.fillStyle = '#fff';
    context.fillRect(0, 0, width, height);
    context.drawImage(bitmap, 0, 0, width, height);

    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (encoded) =>
          encoded ? resolve(encoded) : reject(new Error('Foto konnte nicht komprimiert werden.')),
        'image/jpeg',
        JPEG_QUALITY,
      );
    });
    const baseName = file.name.replace(/\.[^.]+$/, '') || 'reinigung';
    return new File([blob], `${baseName}.jpg`, {
      type: 'image/jpeg',
      lastModified: Date.now(),
    });
  } finally {
    bitmap.close();
  }
}
